import { h, Component } from 'preact'
import BranchAPI from '../api/BranchAPI'
import ErrorMessage from '../components/ErrorMessage'
import Loader from '../components/Loader'
import ProjectsAPI from '../api/ProjectsAPI'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class BranchFilter extends Component {

  constructor(props) {
    super(props)
    this.state = {
      branches: [],
      error: false,
      isLoading: true
    }

    this.handleBranch = this.handleBranch.bind(this)
  }

  componentDidMount() {
    this.fetchBranches()
  }

  fetchBranches() {
      this.setState({
          branches: ProjectsAPI.options(),
          isLoading: false
      })
  }

  handleBranch(e) {
    this.props.onSelectBranch(e.target.value)
  }

  generateOptions() {
    let options = []
    let option_text = 'Alle referenties'

    if (this.props.language == 'en') {
      option_text = 'All references'
    }

    // default option
    options.push(
      <option value="" key="0">{option_text}</option>
    )

    // make an option for each branch
    this.state.branches.map((branch) => {

      // skip branch if it has no projects
      if ( branch.count === 0 ) return false

      return options.push(
        <option
          value={branch.id}
          key={branch.id}
          dangerouslySetInnerHTML={{ __html: branch.name }}
        />
      )
    })

    return options
  }

  generateButtons() {
    let buttons = []

    // default button
    buttons.push(this.generateDefaultButton())

    // make an button for each branch
    this.state.branches.map((branch) => {

      // skip branch if it has no projects
      if ( branch.count === 0 ) return false

      let buttonClass = 'c-button c-project-branches__button'

      if ( this.props.currentBranch == branch.id ) {
        buttonClass = 'c-button c-project-branches__button c-project-branches__button--active'
      }

      return buttons.push(
        <button
          className={buttonClass}
          value={branch.id}
          key={branch.id}
          onClick={this.handleBranch}
          dangerouslySetInnerHTML={{ __html: branch.name }}
        />
      )
    })

    return buttons
  }

  generateDefaultButton() {
    let defaultClass = 'c-button c-project-branches__button'
    let default_text = 'Alle referenties'

    if ( this.props.currentBranch == '' ) {
      defaultClass = 'c-button c-project-branches__button c-project-branches__button--active'
    }

    if (this.props.language == 'en') {
      default_text = 'All references'
    }

    return (
      <button className={defaultClass} value="" onClick={this.handleBranch}>
        {default_text}
      </button>
    )
  }

  render() {
    let {error, isLoading} = this.state

    if (error) {
      return <ErrorMessage type="filter-error" />
    }

    if (isLoading) {
      return <Loader />
    }

    let filter_text = 'Filteren op:'

    if (this.props.language == 'en') {
      filter_text = 'Filter on:'
    }

    return (
        <div className="c-project-branches">
            <div className="filter-label">
                <i className="fas fa-sliders-h"></i> Filters
            </div>

            <div className="c-project-branches__select-filter">
                <select
                    value={this.props.currentBranch}
                    onChange={this.handleBranch}
                    className="c-project-branches__select"
                >
                    {this.generateOptions()}
                </select>
            </div>

            <div className="c-project-branches__buttons-filter">
                {this.generateButtons()}
            </div>

        </div>
    )
  }
}

export default BranchFilter

// WEBPACK FOOTER //
// ./src/js/projects/containers/BranchFilter.js
